import React from 'react';
import { useIntl } from 'react-intl';
import { Container, Divider } from 'semantic-ui-react';
import Dialog from '@/components/dialogs/Dialog';
import MarkdownContainer from '@/components/wrappers/MarkdownContainer';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const ShowNotificationDialog = ({ theme }) => {
  const intl = useIntl();
  const {
    author, createdOn, description, title,
  } = Selectors.useShowNotificationDialog();
  const hide = Events.useHideNotification();

  return (
    <Dialog
      className="aridhia-notification-dialog smallwizard"
      onClose={hide}
      size="small"
      theme={theme}
      title={title}
    >
      <MarkdownContainer value={description} />
      <Divider />
      <Container
        className="aridhia-show-notification-container"
        content={intl.formatMessage({ id: 'notification.created.author.on' }, { name: author, date: createdOn })}
      />
    </Dialog>
  );
};

export default ShowNotificationDialog;
